/** @format */

// バリデーションを行っていない項目に空のバリデーション結果を入れる

export const noValidateMessage = <T extends object>(validateData: T, originValidateData: T) => {
  const validateProps = Object.keys(validateData);
  const originProps = Object.keys(originValidateData);
  const comparisonProps = originProps.filter((index) => validateProps.indexOf(index) === -1);
  let noValidateData = {};
  comparisonProps.forEach((key) => {
    noValidateData = { ...noValidateData, [key]: { isValidate: "", message: "" } };
  });
  const validateResult = {
    ...validateData,
    ...noValidateData,
  };
  return validateResult;
};
